import axios from 'axios';
import React, { useEffect, useState } from "react";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Link, useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import { BASE_URL } from "../../constants/Constants";
import { useSetUser } from "../../contexts/UserContext";
import { useSetUserRegistration } from "../../contexts/UserRegistrationContext";
import { useDebounce } from "../../utils/common";
import { cookieUtils } from "../../utils/cookieUtils";
import style from "../login/login.module.css";
import { _axios } from '../../utils/axios';
//utils 
import { fetchAndVerifyUserDetails } from '../../libs/jwtUtils';
const Login = () => {
  const setUser = useSetUser();
  const setUserRegistration = useSetUserRegistration();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const navigate = useNavigate();
  const [existingLogo, setExistingLogo] = useState<string>('');
  const [logoUrl, setLogoUrl] = useState<string>('');

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Fetch logo
        const logoResponse = await _axios.get(`${BASE_URL}/api/logo`);
        if (logoResponse.data.success === 1) {
          setLogoUrl(logoResponse.data.url);
          if (logoResponse.data.filename) {
            setExistingLogo(logoResponse.data.filename);
          }
        }
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };

    fetchImages();
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleVerify = (token: React.SetStateAction<string>) => {
    setToken(token);
    console.log('recaptcha V3', token);
  };

  const logLoginDetails = async (user: { name: any; role: any; email: any; mobile: any; }) => {
    try {
      const response = await _axios.post(`${BASE_URL}/api/users/log-login`, {

        name: user.name,
        role: user.role,
        email: user.email,
        mobile: user.mobile
      });
      console.log("Login details logged successfully", response);

    } catch (error) {
      console.error("Error logging login details", error);
    }
  };

  const hashPassword = (password: string) => {

    const hashedPassword = btoa(password);
    console.log('Original password:', password);
    console.log('Encoded password:', hashedPassword);
    return hashedPassword;
  };

  const clearAllCookies = () => {
    // Clear all known cookies
    cookieUtils.removeSecureCookie('userDetails');
    cookieUtils.removeSecureCookie('token');
    cookieUtils.removeSecureCookie('subRole');
    // Add any other cookies that need to be cleared
  };

  const onLogin = async () => {
    localStorage.clear();
    clearAllCookies();
    console.log('Login attempt with email/mobile:', email);
    if (email.length === 0 || password.length === 0) {
      ErrorToast("Please enter valid email/number or password");
      return;
    }
    if (!isNaN(Number(email)) && email.length < 10) {
      ErrorToast("Please enter valid mobile number");
      return;
    }
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    const isValid = emailRegex.test(email);
    if (isNaN(Number(email)) && !isValid) {
      ErrorToast("Please enter valid email");
      return;
    }

    try {
      const encodedPassword = hashPassword(password);
      const loginData = !isNaN(Number(email))
        ? { "mobile": email, "password": encodedPassword, "token": token }
        : { "email": email, "password": encodedPassword, "token": token };

      console.log('Sending login data:', JSON.stringify(loginData));

      const response = await _axios.post(`${BASE_URL}/api/users/login`, loginData);

      console.log('Server response:', response.data);

      if (response?.data?.success === 0) {
        ErrorToast(response?.data?.message);
        return;
      }

      if (response?.data?.data?.active === 0) {
        ErrorToast('Your account is currently inactive. Please contact your system administrator to reactivate the account.');
        return;
      }
      

      const data = response?.data?.data;
      // localStorage.setItem('userDetails', JSON.stringify(response?.data?.data));
      cookieUtils.setSecureCookie('userDetails', data, { expires: 1 });

      if (data?.name && data?.role) setUser(data);
      // Store the JWT token in a secure cookie
      cookieUtils.setSecureCookie('token', response?.data?.token, { expires: 1 });

      // Set subRole if it exists in the response
      if (data.subRole) {
        cookieUtils.setSecureCookie('subRole', data.subRole, { expires: 1 });
      }


      // localStorage.setItem('token', response?.data?.token);

      // Log login details
      await logLoginDetails(data);

      if (response?.data?.data?.role === 'System Admin') {
        // localStorage.setItem("isAdminMode", 'true')
        cookieUtils.setSecureCookie('isAdminMode', true, { expires: 1 });
        SuccessToast('Login Successfully')
        navigate('/launch-page');
      } else if (response?.data?.data?.role === 'Level 1') {
        SuccessToast('Login Successfully')
        navigate('/launch-page');
      } else if (response?.data?.data?.role === 'Level 2') {
        SuccessToast('Login Successfully')
        navigate('/launch-page');
      } else if (response?.data?.data?.role === 'Level 3') {
        SuccessToast('Login Successfully')
        navigate('/launch-page');
      } else {
        SuccessToast("Login Successfully");

        // 1️⃣ Fetch, Validate & Decode User Token
        let userDetailsResponse = await fetchAndVerifyUserDetails(response?.data?.data?.user_id);

        console.log("User Details Response:", userDetailsResponse);

        // 2️⃣ Check if User Details Exist or are Empty
        if (!userDetailsResponse?.data?.data || Object.keys(userDetailsResponse.data?.data).length === 0) {
          console.warn("Invalid or empty user details. Redirecting to verification...");
          navigate("/onboarding/verification-page");
          return;
        }

        // 3️⃣ If Token Validation Failed, Ensure `regestration_status = 0`
        if (!userDetailsResponse.success) {
          alert("Something wrong with token")
          return 
        }

        // 4️⃣ Extract Valid User Details
        const userDetails = userDetailsResponse.data?.data;

        // 5️⃣ Store User Details Securely in Cookies
        cookieUtils.setSecureCookie("userRegistrationDetails", userDetails, { expires: 7 });
        localStorage.setItem("userRegistrationDetails",JSON.stringify(userDetails));
        // localStorage.setItem('userRegestrationDetails', JSON.stringify(userDetails))
        setUserRegistration(userDetails);
        navigate("/launch-page");
       
       
      }
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        onLogin();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [email, password, token]);

  const isUserLogin = async () => {
    const userDetails = await localStorage.getItem('userDetails');
    if (userDetails !== null) {
      navigate('/launch-page');
    }
  }

  useEffect(() => {
    isUserLogin();
  }, [navigate]);

  // const loginCallBack =  useCallback(debounce(onLogin,3000),[email, password, token]);
  const loginCallBack = useDebounce(onLogin, 3000);


  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LdRltoqAAAAAKddCuFxu0SGioWr8tMtYSESl_ol">
      <div className={style.loginContainer}>
        <div className={style.loginForm}>
          <div className={style.logo}>
            {/* <img
              src={`${BASE_URL}/api/logo`}
              alt="Logo"
            /> */}
            {logoUrl && (
              <img
                src={logoUrl}
                alt="Logo"
                className={style.companyIcon}
              />
            )}
          </div>
          <div className={style.loginText}>Login</div>
          <br />
          <Input
            title={"Email/Mobile Number"}
            placeholder={"Email/Mobile Number"}
            isIcon={true}
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            title={"Password"}
            placeholder={"Password"}
            isIcon={true}
            icon={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
            type={showPassword ? "text" : "password"}
            onClick={togglePasswordVisibility}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className={style.forgotPassword}>
            <Link to="/onboarding/forgot-password" className={style.greyLink}>Forgot Password?</Link>
          </div>

          <button className={style.loginButton} onClick={loginCallBack} >Login</button>
          {/* <button className={style.loginButton} onClick={debounce(onLogin, 3000)}></button> */}
          <div className={style.createAccount}>
            Don't have an account yet?{" "}
            <Link to="/onboarding/create-account" className={style.greyLink}>Create an account</Link>
          </div>
        </div>
      </div>
      <GoogleReCaptcha onVerify={handleVerify} />
    </GoogleReCaptchaProvider>
  );
};

export default Login;
